export default __webpack_public_path__ + "static/media/plant-cells.a598709a.jpg";